import React from "react";
import {useTranslation} from "next-i18next";

/**
 * Product-Types
 * @type {string[]}
 */
const units = [
    {
        'key':  'g',
        'name': 'gram'
    },
    {
        'key':  'kg',
        'name': 'kilogram'
    },
    {
        'key':  'L',
        'name': 'liter'
    },
    {
        'key':  'ml',
        'name': 'milliliters'
    },
    {
        'key':  'cl',
        'name': 'centilitre'
    }
];

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Unit ({ value })
{
    // init
    const { t } = useTranslation();

    return (
        <>
            <select className="form-select" id="unit" name="unit" defaultValue={value}>
                {units.map((unit) =>
                    <option key={unit.key} value={unit.key}>{t(unit.name, {ns: 'units'})}</option>
                )}
            </select>
        </>
    );
}